import { getEndpoint } from '../endpoints';
import { propertyFields } from '../../utils/propertyFields';
import { conceptionFields } from '../../utils/conceptionFields';
import { raccordementFields } from '../../utils/raccordementFields';
import { formatDateYMD } from '../../utils/formatDate';
import { contactValues } from '../../params';

const defaultPropertyFields = { ...propertyFields, conception: conceptionFields, raccordement: raccordementFields };

export const propertyForm = {
    state: {
        type: 'properties',
        propertyForm: defaultPropertyFields,
        propertyTypes: [],
        networkTypes: [],
        networkProperties: [],
        visitDisposals: [],
        users: [],
        propertyFolderNumber: '',
    },
    getters: {
        getPropertyForm(state) {
            return state.propertyForm;
        },
        getPropertyTypes(state) {
            return state.propertyTypes;
        },
        getUsers(state) {
            return state.users;
        },
        getNetworkTypes(state) {
            return state.networkTypes;
        },
        getNetworkProperties(state) {
            return state.networkProperties;
        },
        getVisitDisposals(state) {
            return state.visitDisposals;
        },
    },
    actions: {
        async submitProperty({ rootState, dispatch, commit, state }, payload) {
            let formData = new FormData();
            const endpoint = getEndpoint(state.type, rootState.route.params.propertyId)[payload.action];
            commit('setExtratFieldsToForm');
            commit('setMultilSelectValue');

            formData.append('data', JSON.stringify(state.propertyForm));

            //Append files
            if (state.propertyForm.conception.attachement !== null) {
                Object.entries(state.propertyForm.conception.attachement).map(([key, values]) => {
                    //photos, sechma ...
                    var exisitingFiles = [];
                    if (Array.isArray(values)) {
                        values.forEach((fileElement, index) => {
                            if (fileElement instanceof File) {
                                let appendTo = `conception.${key}[${index}]`;
                                formData.append(appendTo, fileElement);
                            } else if (fileElement) {
                                delete fileElement.manuallyAdded;
                                delete fileElement._removeLink;
                                exisitingFiles.push(fileElement);
                            }
                        });
                        state.propertyForm.conception.attachement[key] = exisitingFiles.slice();
                    }
                });
            }

            Object.entries(state.propertyForm.raccordement.connections).forEach(([indexConnection, connection]) => {
                if (connection.attachement !== null) {
                    Object.entries(connection.attachement).map(([key, values]) => {
                        //photos, sechma ...
                        var exisitingFiles = [];
                        if (Array.isArray(values)) {
                            values.forEach((fileElement, index) => {
                                if (fileElement instanceof File) {
                                    let appendTo = `connections.${indexConnection}.${key}[${index}]`;
                                    formData.append(appendTo, fileElement);
                                } else if (fileElement) {
                                    delete fileElement.manuallyAdded;
                                    delete fileElement._removeLink;
                                    exisitingFiles.push(fileElement);
                                }
                            });
                            state.propertyForm.raccordement.connections[indexConnection].attachement[
                                key
                            ] = exisitingFiles.slice();
                        }
                    });
                }
            });

            await rootState.app.http.instance
                .post(endpoint, formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    },
                })
                .then(
                    response => {
                        commit('setNotif', response);
                        payload.action == 'create' ? dispatch('redirectToList') : dispatch('redirectToDetail');
                    },
                    error => {
                        console.log(error.message);
                        commit('setNotif');
                        payload.action == 'create' ? dispatch('redirectToList') : dispatch('redirectToDetail');
                    }
                );
        },
        async fetchPropertyTypes({ commit, rootState, state }) {
            const endpoint = getEndpoint(state.type).propertyTypes;

            const { data } = await rootState.app.http.instance.get(endpoint);

            commit('setPropertyTypes', data);
        },
        async fetchUsers({ commit, rootState }) {
            const endpoint = getEndpoint('user').list;

            const { data } = await rootState.app.http.instance.get(endpoint);

            commit('setUsers', data);
        },
        async fetchNetworkTypes({ commit, rootState }) {
            const endpoint = getEndpoint('referential').networkTypes;

            const { data } = await rootState.app.http.instance.get(endpoint);

            commit('setNetworkTypes', data);
        },
        async fetchNetworkProperties({ commit, rootState }) {
            const endpoint = getEndpoint('referential').networkProperties;

            const { data } = await rootState.app.http.instance.get(endpoint);

            commit('setNetworkProperties', data);
        },
        async fetchVisitDisposals({ commit, rootState }) {
            const endpoint = getEndpoint('referential').visitDisposals;

            const { data } = await rootState.app.http.instance.get(endpoint);

            commit('setVisitDisposals', data);
        },
        async getProperty({ rootState, dispatch }) {
            const property = rootState.refProperties.property;
            const towns = rootState.refProperties.towns;

            if (Object.entries(property).length === 0 && property.constructor === Object) {
                dispatch('setIdProperty', { id: rootState.route.params.propertyId });
                dispatch('fetchProperty', { id: rootState.route.params.propertyId }).then(() => {
                    dispatch('fetchTowns').then(() =>
                        dispatch('transformPropertyValue', {
                            property: rootState.refProperties.property,
                            towns: rootState.refProperties.towns,
                        })
                    );
                });
            } else {
                dispatch('transformPropertyValue', { property: property, towns: towns });
            }
        },
        transformPropertyValue({ commit }, payload) {
            const property = payload.property;
            const towns = payload.towns;

            if (property.address !== null && towns !== null) {
                property.numberStreet = property.address.numberStreet;
                property.street = property.address.street;
                property.town = towns.find(town => town.code == property.address.town);
                property.zipCode = property.address.zipCode;
                property.latitude = property.address.latitude;
                property.longitude = property.address.longitude;
                delete property.address;
            }

            //Normalize format date
            property.creationDate = formatDateYMD(property.creationDate);
            if (property.raccordement.connections && property.raccordement.connections.length > 0) {
                property.raccordement.connections.forEach(connection => {
                    connection.connectionRequestDate = formatDateYMD(connection.connectionRequestDate);
                    connection.quotationSendDate = formatDateYMD(connection.quotationSendDate);
                    connection.orderDate = formatDateYMD(connection.orderDate);
                    connection.workStartDate = formatDateYMD(connection.workStartDate);
                    connection.workEndDate = formatDateYMD(connection.workEndDate);
                });
            }

            commit('setPropertyFolderNumber', property.folderNumber);

            delete property.folderNumber;
            delete property.id;

            const findByValue = value => element => value == element.value;
            if (property.contacts && property.contacts.length > 0) {
                property.contacts.forEach((contact, index) => {
                    let allTypes = [];
                    Object.entries(contact.typeContact).map(typecontact => {
                        let type = contactValues.find(findByValue(typecontact[1]));
                        allTypes.push(type);
                    });
                    property.contacts[index].typeContact = allTypes;
                });
            }
            commit('setPropertyFormToEdit', property);

        },
        handleSubmitProperty({ dispatch }) {
            dispatch('submitProperty', { action: `create` });
        },
        handleSubmitEditProperty({ dispatch }) {
            dispatch('submitProperty', { action: `edit` });
        },
        initPropertyForm({ commit }) {
            commit('initPropertyForm');
        },
    },
    mutations: {
        setMultilSelectValue(state) {
            if (state.propertyForm.contacts && state.propertyForm.contacts.length > 0) {
                state.propertyForm.contacts.forEach((contact, index) => {
                    contact.typeContact.forEach((typecontact, key) => {
                        state.propertyForm.contacts[index].typeContact[key] = typecontact.value;
                    });
                });
            }
            if (state.propertyForm.propertyType) {
                state.propertyForm.propertyType = state.propertyForm.propertyType.id;
            }

            if (state.propertyForm.town) {
                state.propertyForm.town = state.propertyForm.town.code;
            }
        },
        setPropertyForm(state, payload) {
            Object.entries(payload).map(([key, val]) => {
                if (val && typeof val === 'object' && val.constructor === Object) {
                    if (typeof val.id !== 'undefined') {
                        payload[key] = val.id;
                    }
                }
            });

            state.propertyForm = payload;
        },
        setPropertyFormToEdit(state, payload) {
            state.propertyForm = payload;
        },
        setPropertyFolderNumber(state, propertyFolderNumber) {
            state.propertyFolderNumber = propertyFolderNumber;
        },
        initPropertyForm(state) {
            state.propertyForm = {
                responsibleId: null,
                responsibleFirstname: null,
                responsibleLastname: null,
                responsibleEmail: null,
                complianceSurveyOnly: null,
                town: null,
                street: null,
                numberStreet: null,
                zipCode: null,
                isBanValid: null,
                creationDate: null,
                propertyType: null,
                propertyTypeOther: null,
                contacts: [],
                conception: {
                    folderNumberOfConnection: null,
                    newBuildingPermit: null,
                    subsidizedWork: null,
                    compliance: null,
                    zac: null,
                    roadConstruction: null,
                    numberBuldingPermit: null,
                    yearBulidingPermit: null,
                    plotSurface: null,
                    topsoilInGround: null,
                    topsoilInSlab: null,
                    simpleRoof: null,
                    gravelledTerraceRoof: null,
                    otherSurfaceType: null,
                    activeSurface: null,
                    observations: null,
                    totalDisconnectionRainWater: null,
                    partialDisconnectionRainWater: null,
                    disconnectionOfRainwater: null,
                    leakFlowRate: null,
                    rateVolume: null,
                    surfaceDisconnect: null,
                    works: [],
                },
                raccordement: { connectedNetwork: null, epConnectedPublicSanitationNetwork: null, connections: [] },
            };
            state.propertyForm.conception.attachement = {
                photos: [],
                schemas: [],
                technicalFiles: [],
                reports: [],
                conventions: [],
                others: [],
            };
        },
        setPropertyTypes(state, payload) {
            state.propertyTypes = payload;
        },
        setUsers(state, payload) {
            state.users = payload;
        },
        setNetworkTypes(state, payload) {
            state.networkTypes = payload;
        },
        setNetworkProperties(state, payload) {
            state.networkProperties = payload;
        },
        setVisitDisposals(state, payload) {
            state.visitDisposals = payload;
        },
        setExtratFieldsToForm(state) {
            if (state.propertyForm.responsibleId !== null) {
                var user = state.users.find(function (user) {
                    return user.id == state.propertyForm.responsibleId;
                });
                if (user) {
                    state.propertyForm.responsibleFirstname = user.firstName;
                    state.propertyForm.responsibleLastname = user.lastName;
                    state.propertyForm.responsibleEmail = user.email;
                }
            }
        },
    },
};
